import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@/components/providers/theme-provider';
import { Providers } from '@/components/providers';
import { Toaster } from 'sonner';
import { BabelLoader } from '@/components/babel-loader';
import { ChunkErrorHandler } from '@/components/chunk-error-handler';

// 导入共享的 SSO 回调页面
import { SSOCallbackPage } from '@blendviewer/ui';

// Lazy load pages
const HomePage = lazy(() => import('./pages/HomePage'));
const PlaygroundPage = lazy(() => import('./pages/PlaygroundPage'));
const ProblemsPage = lazy(() => import('./pages/ProblemsPage'));
const ProblemDetailPage = lazy(() => import('./pages/ProblemDetailPage'));
const CreativePage = lazy(() => import('./pages/CreativePage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

function App() {
  return (
    <div className="font-sans">
      {/* Chunk 加载错误处理 */}
      <ChunkErrorHandler />

      {/* 动态加载 Babel Standalone */}
      <BabelLoader />

      <ThemeProvider
        attribute="class"
        defaultTheme="system"
        enableSystem
        disableTransitionOnChange
      >
        <Providers>
          <BrowserRouter>
            <Suspense fallback={<div className="flex h-screen items-center justify-center">Loading...</div>}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/playground" element={<PlaygroundPage />} />
                <Route path="/problems" element={<ProblemsPage />} />
                <Route path="/problems/:id" element={<ProblemDetailPage />} />
                <Route path="/creative" element={<CreativePage />} />
                {/* OAuth 回调 - 使用共享 SSO 组件 */}
                <Route
                  path="/oauth/callback"
                  element={
                    <SSOCallbackPage
                      onSuccess={() => {
                        // 登录成功后跳转到首页
                        window.location.href = '/?t=' + Date.now();
                      }}
                    />
                  }
                />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Suspense>
          </BrowserRouter>
          <Toaster richColors position="top-center" />
        </Providers>
      </ThemeProvider>
    </div>
  );
}

export default App;

